
import { useSelector } from 'react-redux';
import { RootState } from '../../Store';
import Footer from '../footer/Footer';
import LandingpageHeader from '../header/LandingpageHeader';
import styles from './landingpage.module.scss';
import LandingPageAnonymous from './LandingPageAnonymous';
import LandingPageKunde from './LandingPageKunde';
import LandingPageMitarbeiter from './LandingPageMitarbeiter';

export default function LandingPage() {

    //const dispatch = useDispatch<AppDispatch>();
    //const { t } = useTranslation();
    const auth = useSelector((state: RootState) => state.authSlice.auth);

    return (
        <div className={styles.landingpageContainer}>

            {auth.isAuthCheckFinished === false &&
                <><div>Lädt...</div></>
            }
 
            <LandingpageHeader />     

            {auth.isAuthCheckFinished && auth.isAuthenticated === false &&
                <LandingPageAnonymous />
            }

            {auth.isAuthCheckFinished && auth.isAuthenticated === true &&
                <>
                    {auth.user?.rollen.includes("kunde") && <LandingPageKunde />}
                    {auth.user?.rollen.includes("mitarbeiter") && <LandingPageMitarbeiter />}
                    <Footer />
                </>}

        </div>
    );
}
